import {
  hasHeroClusterRaster,
  HERO_CLUSTER_RASTER,
} from '../../assets/marketing/hero/heroClusterExport';
import heroCircleScene from '../../assets/marketing/hero-circle-scene.svg';
import { ResponsiveImage } from './ResponsiveImage';

const HERO_SIZES = '(min-width: 1200px) 520px, (min-width: 880px) 42vw, 100vw';

type Props = {
  classNameImage?: string;
  /** Use `""` for purely decorative photo clusters; informative for the SVG stand-in. */
  alt: string;
};

/**
 * Right-column hero art for `social_visuals_v1`: WebP+PNG `ResponsiveImage` when `HERO_CLUSTER_RASTER`
 * is configured; otherwise the existing placeholder SVG.
 */
export function HeroMarketingVisual({ classNameImage, alt }: Props) {
  if (hasHeroClusterRaster() && HERO_CLUSTER_RASTER) {
    const { webp, fallback, intrinsic } = HERO_CLUSTER_RASTER;
    return (
      <ResponsiveImage
        webp={webp}
        fallback={fallback}
        sizes={HERO_SIZES}
        width={intrinsic.w}
        height={intrinsic.h}
        alt={alt}
        className={undefined}
        classNameImage={classNameImage}
        priority
      />
    );
  }
  return (
    <img
      className={classNameImage}
      src={heroCircleScene as unknown as string}
      width={560}
      height={360}
      alt={alt}
      loading="eager"
      decoding="async"
      fetchPriority="high"
    />
  );
}
